import { generateId } from '@freelancer/datastore/testing/helpers';
import type { AdminProfileHistory } from './admin-profile-history.model';

export interface GenerateAdminProfileHistoryOptions {
  readonly id?: number;
  readonly userId?: number;
  readonly fieldType?: string;
  readonly fieldValue?: string;
  readonly notes?: string;
  readonly updatedAt?: number;
}

export function generateAdminProfileHistoryObject({
  id = generateId(),
  userId = generateId(),
  fieldType = 'profile_description',
  fieldValue = 'profile description',
  notes = 'profile description notes',
  updatedAt = Date.now(),
}: GenerateAdminProfileHistoryOptions): AdminProfileHistory {
  return {
    id,
    userId,
    fieldType,
    fieldValue,
    notes,
    updatedAt,
  };
}
